import { render, staticRenderFns } from "./CustomPartnerTariffs.vue?vue&type=template&id=57c2fc1e&"
import script from "./CustomPartnerTariffs.vue?vue&type=script&lang=ts&"
export * from "./CustomPartnerTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports